// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".badge-page-badgePageContainer--3dPelaQT9OToAHyqglOWU_{height:calc(100vh - 26px)}", "",{"version":3,"sources":["webpack://src/pages/Badge/badgePage.module.scss"],"names":[],"mappings":"AAAA,uDACC,yBAAA","sourcesContent":[".badgePageContainer {\r\n\theight: calc(100vh - 26px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badgePageContainer": "badge-page-badgePageContainer--3dPelaQT9OToAHyqglOWU_"
};
export default ___CSS_LOADER_EXPORT___;
